/* eslint-disable @typescript-eslint/no-use-before-define */
import { combine, createEffect, createEvent, createStore } from 'effector'
import connectLocalStorage from 'effector-localstorage'

import { $user, $userLoading } from '../Defaults/store'
import { $getPingLoading, $globalLoading } from '../App/store'
import { $getTranslated, $translated } from '../Translated/store'
import { $getLanguages, $languages } from '../Languages/store'
import { AuthParams } from '../../shared/enum'
import { openUrl } from '../../utils'
import { $getDefaults, $getUser } from '../Defaults/event'
import { getApplicationPingFx, getProjectsPingFx } from '../App/event'

export const setCashQueryFx = createEvent<Record<string, unknown>>()

export const getQueryParamsFx = createEffect(() => {
  const result: Record<string, unknown> = {}
  const enableParams = [AuthParams.INVITE_ID, AuthParams.ENABLED_PASSWORD]

  const query = new URLSearchParams(window.location.search)
  enableParams.forEach((key) => {
    const value = query.get(key)
    if (!value) {
      return
    }
    result[key] = decodeURIComponent(value)
  })

  return result
})

export const getQueryParamsParsFx = createEffect(() => {
  const cashQuery = $cashQuery.getState()
  const enableParams = [
    [AuthParams.INVITE_ID, cashQuery[AuthParams.INVITE_ID]],
    [AuthParams.ENABLED_PASSWORD, cashQuery[AuthParams.ENABLED_PASSWORD]],
  ]
  const currentQuery = $appQuery.getState()

  enableParams.forEach(([key, value]) => {
    if (key === AuthParams.INVITE_ID && !!value && !!currentQuery[key] && currentQuery[key] === value) {
      const user = $user.getState()
      const languages = $languages.getState()

      let temp: Record<string, string[]> = {}

      languages.forEach(({ code, countries }) => {
        temp[code] = countries
      })

      const code = languages.map(({ code }) => {
        const arrInclude = temp[code] || []
        return arrInclude
          .find((c) => c.toUpperCase() === user.country?.toUpperCase())
          ? code
          : undefined
      }).filter(Boolean)[0]

      openUrl(`https://${window.location.host.replace('my.', '')}${code ? `/${code}` : ''}`)
    }
  })
})

export const $setInit = createEffect(() => {
  $getTranslated(null)
  $getLanguages(null)
  $getDefaults(null)
  $getUser(null)
  getApplicationPingFx(null)
  getProjectsPingFx(null)
  getQueryParamsFx()
  getQueryParamsParsFx()
})

export const $isInit = combine(
  $translated,
  $languages,
  $userLoading,
  $getPingLoading,
  $globalLoading,

  (t, l, a1, a2, gl) => {
    return (t) && (l.length) && !a1 && !a2 && !gl
  },
)

export const $appQuery = createStore<Record<string, unknown>>({})
  .on(getQueryParamsFx.done, (_, query) => query.result)

const cashQueryLocalStore = connectLocalStorage('cash-query')
export const $cashQuery = createStore<Record<string, unknown>>(cashQueryLocalStore.init() || {})
  .on(getQueryParamsFx.done, (prev, { result }) => ({ ...prev, ...result }))
  .on(setCashQueryFx, (prev, current) => ({ ...prev, ...current }))
$cashQuery.watch(cashQueryLocalStore)
